<template>
  <div>{{ data.text }}</div>
  <v-autocomplete
    return-object
    :items="schoolList"
    label="Intézmény neve"
    hint="Kezdje el beírni az intézmény nevét, majd válasszon a listából"
    variant="underlined"
    @update:search="filterSchools"
    :list-props="{maxWidth:'1500px'}"
    v-model="value"
  >
    <template #no-data>
      <v-list-item>Nincs találat. Kezdjen el gépelni!</v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { defineComponent } from 'vue'
import { getAllInstitutions } from '../../services/adminServices'

export default defineComponent({
  name: 'InstituteComponent',
  props: {
    data: Object,
    baseValue: [Object, String, Array, Boolean],
  },
  data: (props) => {
    return {
      value: props.baseValue,
      schoolList: [],
      schools: [],
    }
  },
  async created() {
    const institutions = await getAllInstitutions()
    if (institutions) {
      this.schools = institutions
    }
  },
  emits: ['formModEvent'],
  watch: {
    value() {
      this.sendDataToParent()
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = [
        {
          key: this.data.name,
          value: this.value,
        },
      ]
      this.$emit('formModEvent', dataToSend)
    },
    filterSchools(val) {
      if (val.length > 2) {
        this.schoolList = this.schools.filter((school) => {
          return school.title.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
    },
  },
})
</script>
